import { render } from "./AdminShellPage.vue?vue&type=template&id=fdf0a6c2&scoped=true"
import script from "./AdminShellPage.vue?vue&type=script&lang=js"
export * from "./AdminShellPage.vue?vue&type=script&lang=js"

import "./AdminShellPage.vue?vue&type=style&index=0&id=fdf0a6c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf0a6c2"]])

export default __exports__